import { NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
// import __megamenu from "./jsons/__megamenu.json";

// const megaMenuDemo: MegamenuItem[] = [
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "Company",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "#",
//       name: i.Company,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "App Name",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "#",
//       name: i.AppName,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/5059013/pexels-photo-5059013.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "City",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "#",
//       name: i.City,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/5159141/pexels-photo-5159141.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "Contruction",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "#",
//       name: i.Contruction,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/7473041/pexels-photo-7473041.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "Country",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "#",
//       name: i.Country,
//     })),
//   },
// ];

const categoryPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/listing?category=Outdoor",
    name: "Outdoor",
  },

  {
    id: ncNanoId(),
    href: "/listing?category=Gadget",
    name: "Gadget",
  },
  {
    id: ncNanoId(),
    href: "/listing?category=Transportasi",
    name: "Transportasi",
  },
  {
    id: ncNanoId(),
    href: "/listing?category=Pakaian",
    name: "Pakaian",
  },
  {
    id: ncNanoId(),
    href: "/listing?category=Keperluan Anak",
    name: "Keperluan Anak",
  },
  {
    id: ncNanoId(),
    href: "/listing?category=Furnitur",
    name: "Furnitur",
  },

  {
    id: ncNanoId(),
    href: "/listing?category=Keperluan Pribadi",
    name: "Keperluan Pribadi",
  },
];

const locationPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/map?location=kintamani",
    name: "Kintamani",
  },

  {
    id: ncNanoId(),
    href: "/map?location=buyan",
    name: "Buyan - Tamblingan",
  },
  {
    id: ncNanoId(),
    href: "/map?location=denpasar-barat",
    name: "Denpasar Barat",
  },
  {
    id: ncNanoId(),
    href: "/map?location=denpasar-timur",
    name: "Denpasar Timur",
  },
  {
    id: ncNanoId(),
    href: "/map?location=denpasar-selatan",
    name: "Denpasar Selatan",
  },
  {
    id: ncNanoId(),
    href: "/map?location=denpasar-utara",
    name: "Denpasar Utara",
  },
];

const otherPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/snk",
    name: "Syarat dan Ketentuan",
  },
  {
    id: ncNanoId(),
    href: "/blog",
    name: "Blog",
  },
];

// const templatesChildrenMenus: NavItemType[] = [
//   {
//     id: ncNanoId(),
//     href: "/add-listing-1",
//     name: "Add Listings",
//     type: "dropdown",
//     children: [
//       {
//         id: ncNanoId(),
//         href: "/add-listing-1",
//         name: "Add Listings 1",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-2",
//         name: "Add Listings 2",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-3",
//         name: "Add Listings 3",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-4",
//         name: "Add Listings 4",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-5",
//         name: "Add Listings 5",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-6",
//         name: "Add Listings 6",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-7",
//         name: "Add Listings 7",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-8",
//         name: "Add Listings 8",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-9",
//         name: "Add Listings 9",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-10",
//         name: "Add Listings 10",
//       },
//     ],
//   },
//   //
//   { id: ncNanoId(), href: "/checkout", name: "Checkout" },
//   { id: ncNanoId(), href: "/pay-done", name: "Pay done" },
//   //
//   { id: ncNanoId(), href: "/author", name: "Author Page" },
//   { id: ncNanoId(), href: "/account", name: "Account Page" },
// ];

export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Beranda",
  },
  // {
  //   id: ncNanoId(),
  //   href: "#",
  //   name: "Five columns",
  //   type: "megaMenu",
  //   megaMenu: megaMenuDemo,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "#",
  //   name: "Listing Page",
  //   type: "dropdown",
  //   children: [
  //     { id: ncNanoId(), href: "/listing-stay", name: "Stay page" },
  //     { id: ncNanoId(), href: "/listing-stay-map", name: "Stay page (map)" },
  //     { id: ncNanoId(), href: "/listing-stay-detail", name: "Stay Detail" },
  //     //
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-experiences",
  //       name: "Experiences page",
  //     },
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-experiences-map",
  //       name: "Experiences page (map)",
  //     },
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-experiences-detail",
  //       name: "Experiences Detail",
  //     },
  //     //
  //     { id: ncNanoId(), href: "/listing-car", name: "Cars page" },
  //     { id: ncNanoId(), href: "/listing-car-map", name: "Cars page (map)" },
  //     { id: ncNanoId(), href: "/listing-car-detail", name: "Car Detail" },
  //   ],
  // },
  // {
  //   id: ncNanoId(),
  //   href: "#",
  //   name: "Templates",
  //   type: "dropdown",
  //   children: templatesChildrenMenus,
  // },
  {
    id: ncNanoId(),
    href: "/map",
    name: "Lokasi",
    type: "dropdown",
    children: locationPageChildMenus,
  },
  {
    id: ncNanoId(),
    href: "/listing",
    name: "Kategori",
    type: "dropdown",
    children: categoryPageChildMenus,
  },
  {
    id: ncNanoId(),
    href: "/snk",
    name: "Berita dan Info",
    type: "dropdown",
    children: otherPageChildMenus,
  },
];
